import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_URL + "/v1/";

class TestRunsService {
  getMyTestRuns() {
    // console.log(`TestRunsService API_URL = ${API_URL}`);
    return axios.get(API_URL + "testruns/user", { headers: authHeader() });
  }

  getAllTestRuns() {
    return axios.get(API_URL + "testruns/all", { headers: authHeader() });
  }

  getATestRun(testRunID) {
    console.log(`TestRunsService testRunID: "${testRunID}"`);
    return axios.get(API_URL + "testruns/" + testRunID, {
      headers: authHeader(),
    });
  }

  deleteATestRun(testRunID) {
    console.log(`TestRunsService DELETE testRunID: "${testRunID}"`);
    return axios.delete(API_URL + "testruns/" + testRunID + "?REQ=vue", {
      headers: authHeader(),
    });
  }

  // createTestRun(data) {
  //   console.log(`createTestRun received: "${JSON.stringify(data, null, 2)}"`);
  //   return axios.post(API_URL + 'testruns/', data, { headers: authHeader() });
  // }

  createTestRun(data) {
    // console.log(`createTestRun received: "${JSON.stringify(data, null, 2)}"`);
    return axios.post(API_URL + "testruns/", data, { headers: authHeader() });
  }

  getProjects() {
    return axios.get(API_URL + "projects", { headers: authHeader() });
  }

  getProjectSuites(projectID) {
    // console.log(`TestRunsService projectID: "${projectID}"`);
    return axios.get(API_URL + "testsuites/?project=" + projectID, {
      headers: authHeader(),
    });
  }
}

export default new TestRunsService();
